
(function containerTypeModuleDefinition() {

    'use strict';

    angular.module('ContainerType', ['ui.router', 'Config', 'Entities', 'ClickOnce', 'CustomControls'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function containerTypeConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('container-type-add', {
                    url: "/ContainerType/Add",
                    templateUrl: config.resourceUrl('/views/container-type/add-modify.html'),
                    controller: 'ContainerTypeAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('CONTAINERTYPE WRITE')
                });

                $stateProvider.state('container-type-modify', {
                    url: "/ContainerType/Modify/{id}",
                    templateUrl: config.resourceUrl('/views/container-type/add-modify.html'),
                    controller: 'ContainerTypeModifyController',
                    authorize: true,
                    roles: loginProvider.roleCondition('CONTAINERTYPE WRITE')
                });

                $stateProvider.state('container-type-find', {
                    url: "/ContainerType/List",
                    templateUrl: config.resourceUrl('/views/container-type/list.html'),
                    controller: 'ContainerTypeFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('CONTAINERTYPE READ').or('CONTAINERTYPE WRITE')
                });

                $stateProvider.state('container-type-detail', {
                    url: '/ContainerType/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/container-type/detail.html'),
                    controller: 'ContainerTypeDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('CONTAINERTYPE READ').or('CONTAINERTYPE WRITE')
                });

                $stateProvider.state('container-type-metadata', {
                    url: '/ContainerType/AssociateMetadata/{id}',
                    templateUrl: config.resourceUrl('/views/container-type/associate-metadata.html'),
                    controller: 'ContainerTypeAssociateMetadataController'
                    , authorize: true,
                    roles: loginProvider.roleCondition('CONTAINERTYPE WRITE')
                });

                $stateProvider.state('container-type-document-type', {
                    url: '/ContainerType/AssociateDocumentType/{id}',
                    templateUrl: config.resourceUrl('/views/container-type/associate-document-type.html'),
                    controller: 'ContainerTypeAssociateDocumentTypeController'
                   , authorize: true,
                    roles: loginProvider.roleCondition('CONTAINERTYPE WRITE')
                });

                $stateProvider.state('container-type-import-settings', {
                    url: '/ContainerType/ImportSettings/{id}',
                    templateUrl: config.resourceUrl('/views/container-type/import-settings.html'),
                    controller: 'ContainerTypeImportSettingsController'
                  , authorize: true,
                   roles: loginProvider.roleCondition('CONTAINERTYPE WRITE')
                });

                $stateProvider.state('container-type-import', {
                    url: '/ContainerType/Import/',
                    templateUrl: config.resourceUrl('/views/container-type/import.html'),
                    controller: 'ContainerTypeImportController'
                    , authorize: true,
                    roles: loginProvider.roleCondition('CTDT EXPORT IMPORT')
                });
            }
        ]);
})();